import type { CountryCode, LanguageCode } from "@/gql/types";
import type { LOCALES } from "./language";

export type CountryLabel = "croatia" | "europe" | "germany";

export type Locale = {
  translationLanguage?: string;
  language: LanguageCode;
  country: CountryCode;
  label: CountryLabel;
  pathPrefix?: string;
  flagSrc: string;
};

export type Countries = Record<(typeof LOCALES)[number], Locale>;

export const countries: Countries = {
  hr: {
    language: "HR",
    country: "HR",
    label: "croatia",
    pathPrefix: "/hr",
    flagSrc: "/styles/assets/flag-hr.svg",
  },
  de: {
    language: "DE",
    country: "HR",
    label: "germany",
    pathPrefix: "/de",
    flagSrc: "/styles/assets/flag-de.svg",
  },
} as const;

export const getCountryVariables = (locale: keyof typeof countries) => {
  return {
    country: countries[locale].country,
    language: countries[locale].language,
  };
};
